export type Faq = {
  q: string
  a: string
}

export const faqs: Faq[] = [
  {
    q: '¿Para quién está pensado el Kit?',
    a: 'Está dirigido a terapeutas y practicantes con formación previa en Medicina China que quieren continuar estudiando y ampliar su mirada sobre distintas ramas de la disciplina.',
  },
  {
    q: '¿Es un curso o una certificación?',
    a: 'No. Es una biblioteca de estudio en formato digital. No incluye clases, tutorías ni certificación.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: 'Después de confirmarse el pago, recibís el acceso digital al material en el correo asociado a tu compra.',
  },
  {
    q: '¿Puedo leerlo sin imprimirlo?',
    a: 'Sí. Podés leer los PDF en computadora, celular o tablet. También podés imprimir las páginas que te resulten útiles para estudiar.',
  },
  {
    q: '¿Incluye imágenes con puntos específicos de acupuntura marcados sobre el cuerpo?',
    a: 'El Kit se centra en fundamentos, marcos de estudio y principios generales de distintas ramas de la MTC. No se presenta como un atlas milimétrico de localización de puntos específicos ni reemplaza la supervisión de tu formación profesional.',
  },
  {
    q: '¿Puedo compartir los archivos con otras personas?',
    a: 'La compra es para uso individual. Los materiales están protegidos por derechos de autor y no se permite su reproducción o redistribución sin autorización.',
  },
  {
    q: '¿Tiene garantía?',
    a: 'Sí. La compra incluye una garantía de 7 días, según las condiciones informadas al momento de la compra.',
  },
]
